import Footer from "../../footer"
import NavBar from "../../nav"

const LegalInterpretations = () => {
  return <div className='legal-interpretations'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Legal Interpretations</h1>
				<div className="headline-divider sections"></div>
				<h2>Interpreting the Interpretations</h2>	
				<h3>Legal interpretations do not expire.</h3>		
			</div>	
		</section>
    <section className="clean-block clearfix">	
			<div className="container content-container about-container">	
				<div className="prose">If an interpretation implies a contradiction to a previous interpretation for the scenario, it may or may not supersede the previous interpretation. Pilots should be very careful when evaluating a later interpretation, as the earlier interpretation may still be valid for the scenario. Following the guidance of a recent interpretation may not be germane to the scenario presented.</div>
				<div className="prose">View our answers to <a href="/regulations" >Frequently Asked Regulations (FARs)</a>.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default LegalInterpretations